export default {
	TASKS: 'companies/:company_id/tasks/',
	TASKS_CENTER: 'companies/:company_id/task_center/',
	RTM_CENTER: 'companies/:company_id/rtm_center/'
}